
<div class="job-dialog">

  <div class="content">
    <h1 > {{isNew ? "Créer nouveau véhicule"  : "Mettre à jour infos véhicule " }}</h1>
    <form #carEditForm="ngForm" class="car-form">
      <div hidden>
        <mat-form-field >
          <input type="text" matNativeControl matInput="" name ="id" placeholder="Id"  [(ngModel)] = "data.carId" >
        </mat-form-field>
      </div >

      <mat-form-field >
        <mat-label>Marque</mat-label>
        <mat-select required name = "make" (selectionChange)="onMakeChange($event.value)" [(ngModel)]="selectedMake">
          @for (make of (makes$ | async)!; track make; let i = $index) {
            <mat-option [value]="make" >{{make.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (data.make !='') {
        <mat-form-field >
          <mat-label>Modele</mat-label>
          <mat-select matNativeControl required name = "model" [disabled]="!(selectedMake.id>0)" (selectionChange)="onModelChange($event.value)" [(ngModel)]="selectedModel">
            @for (model of (models$ | async)!; track model) {
              <mat-option [value]="model"> {{model.makeName}}  {{model.name}} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <!--
      <mat-form-field *ngIf="data.make !=''" >
        <mat-label>Version</mat-label>
        <mat-select matNativeControl required name = "version" [disabled]="!(selectedModel.id>0)" (selectionChange)="onVersionChange($event.value)" [(ngModel)]="selectedVersion">
          <mat-option *ngFor="let version of (versions$ | async)!;" [value]="version"> {{version.makeName}}  {{version.modelName}}  {{version.name}} </mat-option>
        </mat-select>
      </mat-form-field>
      -->

      @if (data.make !='') {
        <mat-form-field >
          <mat-label>Version</mat-label>
          <mat-select matNativeControl name = "version" [disabled]="!(selectedModel.id>0)" (selectionChange)="onVersionChange($event.value)" [(ngModel)]="selectedVersion">
            @for (versionn of selectedModel.versions; track versionn) {
              <mat-option [value]="versionn"> {{selectedModel.makeName}}  {{selectedModel.name}}  {{versionn}} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (data.model !='') {
        <mat-form-field >
          <mat-label>Moteur</mat-label>
          <mat-select matNativeControl name = "engine" [disabled]="!(selectedModel.id>0)" (selectionChange)="onEngineChange($event.value)" [(ngModel)]="selectedEngine">
            @for (engine of selectedModel.engines; track engine) {
              <mat-option [value]="engine"> {{engine.id}} - {{engine.ref}}  {{engine.name}}  {{engine.powerHp}} CV </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (data.version!='') {
        <mat-form-field>
          <mat-label>Features</mat-label>
          <mat-select multiple matNativeControl name = "features" [(ngModel)] = "data.features">
            @for (feature of ( features$ | async)!; track feature) {
              <mat-option [value]="feature.name"> {{feature.code}} - {{feature.name}} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <!-- <mat-form-field *ngIf = "data.model !=''" >
      <mat-label>Body Type</mat-label>
      <mat-select matNativeControl  required name = "bodyType" [(ngModel)] = "data.bodyType">
        <mat-option *ngFor="let t of carBodyTypes;" [value]="t"> {{t}} </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.model!=''">
      <mat-label>Année</mat-label>
      <input type="number" matInput="" name ="year" placeholder="First Registration"  [(ngModel)] = "data.year" >
    </mat-form-field>
    -->

    @if (data.model!='') {
      <mat-form-field>
        <mat-label >Carburant</mat-label>
        <mat-select required  name="fuel"  [(ngModel)]="data.fuel" >
          @for (fuel of carFuels; track fuel; let i = $index) {
            <mat-option [value]="fuel" >{{fuel}}</mat-option>
          }
        </mat-select>
        <!-- <mat-radio-group
        aria-labelledby="example-radio-group-label" required class="example-radio-group" name="fuel" [(ngModel)] = "data.fuel">
        <mat-radio-button class="example-radio-button" *ngFor="let f of carFuels; index as i"  [value]="f">
          {{f}}
        </mat-radio-button>
      </mat-radio-group> -->
    </mat-form-field>
  }


  @if (data.fuel !='' ) {
    <mat-form-field>
      <mat-label>Boite</mat-label>
      <mat-select required  name="gearbox"  [(ngModel)]="data.gearBox" >
        @for (gear of carGearBoxes; track gear; let i = $index) {
          <mat-option [value]="gear" >{{gear}}</mat-option>
        }
      </mat-select>
      <!-- <mat-radio-group
      aria-labelledby="example-radio-group-label" class="example-radio-group" name="gearbox" [(ngModel)] = "data.gearbox">
      <mat-radio-button class="example-radio-button" *ngFor="let g of carGearBoxes; index as i"  [value]="g">
        {{g}}
      </mat-radio-button>
    </mat-radio-group> -->
  </mat-form-field>
}

@if (data.gearBox!='') {
  <mat-form-field>
    <mat-label>Année</mat-label>
    <mat-select matNativeControl required name = "year" [(ngModel)] = "data.year">
      @for (year of carYearsBD; track year) {
        <mat-option [value]="year"> {{year}} </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (data.year > 0) {
  <mat-form-field>
    <mat-label>Kilometrage</mat-label>
    <input type="number" required matInput="" name ="mileage" step="1000" placeholder="mileage"  [(ngModel)] = "data.mileage" >
  </mat-form-field>
}

@if (data.year > 0) {
  <mat-form-field>
    <mat-label>Puissance (CV)</mat-label>
    <input type="number" required matInput="" name ="powerHp" step="1" placeholder="powerHp"  [(ngModel)] = "data.powerHp" >
  </mat-form-field>
}


@if (data.mileage > 0) {
  <mat-form-field>
    <mat-label>Pays</mat-label>
    <mat-select required  name="country" (selectionChange)="updateCitiesBD(data.country);" [(ngModel)]="data.country" >
      @for (country of countryCodeOptions; track country; let i = $index) {
        <mat-option [value]="country" >{{getCountry(country).name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (data.mileage > 0) {
  <mat-form-field >
    <mat-label>Ville</mat-label>
    <mat-select matNativeControl [disabled]="data.country===''" required name = "city" [(ngModel)]="data.city">
      @for (city of citiesBD; track city) {
        <mat-option [value]="city"> {{city}} </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (data.mileage > 0 && isNew) {
  <mat-form-field>
    <mat-label>Prix vente ({{getCountry(data.country).currency}}) </mat-label>
    <input type="number" required minlength=3 matInput="" name ="buyPrice" step="1000" placeholder="Prix vente"  [(ngModel)]="data.buyPrice.amount" >
  </mat-form-field>
}

@if (data.mileage > 0 && isNew) {
  <mat-form-field>
    <mat-label>Prix location ({{getCountry(data.country).currency}}/J)</mat-label>
    <input type="number" required matInput="" name ="rentPrice" step="1000" placeholder="Prix location"  [(ngModel)]="data.rentDayRate.amount" >
  </mat-form-field>
}


<!--
<mat-form-field *ngIf = "data.model !=''">
  <input type="text" matInput="" name ="variant" placeholder="Variant"  [(ngModel)] = "data.variant" >
</mat-form-field>

<mat-form-field *ngIf = "data.id !=''">
  <input type="text" matInput="" name ="id" placeholder="Id"  [(ngModel)] = "data.id" >
</mat-form-field>


<p *ngIf = "updateMode">
  <label id="example-radio-group-label">Body Type</label>
  <br />
  <mat-radio-group
    aria-labelledby="example-radio-group-label" class="example-radio-group" name="bodyType" [(ngModel)] = "data.bodyType">
    <mat-radio-button class="example-radio-button" *ngFor="let type of carBodyTypes; index as i"  [value]="type">
      {{type}}
    </mat-radio-button>
  </mat-radio-group>

</p>


<p style="color: orange">{{ formMessage }} </p>
-->

<!--
<p> {{!updateMode ? "Create new data"  : "Update data Infos" }}
  <button (click) = "toggleMode()" class="link" >{{updateMode ? "Show body type"  : "Hide body type" }}</button>

</p>
-->
</form>

<div class="action-buttons">
  <button class ="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
  <button class ="cta-button-buy" [disabled] = !carEditForm.valid mat-button [mat-dialog-close]="data" cdkFocusInitial> {{isNew ? "Créer"  : "Enregistrer " }} </button>
</div>
</div>
